export default __webpack_public_path__ + "static/media/icon-3.3011919d.svg";